module.exports = __webpack_public_path__ + "img/padlock.d5ea7a80.png";